import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Hero from 'common/Hero'
import HeroTitle from 'common/Hero/title'
import HeroSubtitle from 'common/Hero/subtitle'

import PageContent from 'common/PageContent'
import Section from 'common/Section'
import SectionTitle from 'common/Section/title'
import PositionsTable from 'views/common/PositionsTable'
import DepartmentsTable from 'views/Departments/table'

import { setTitle } from 'reducers/global'
import { capitalize } from 'services/string'

class DepartmentDetail extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    const name = this.getName(props)

    props.dispatch(setTitle(capitalize(name)))
  }

  componentDidUpdate (prevProps, prevState) {
    const name = this.getName(prevProps)
    const newName = this.getName(this.props)

    if (name !== newName) {
      this.props.dispatch(setTitle(capitalize(newName)))
    }
  }

  getName (props) {
    return props.match.params.departmentId.replace('_', ' ')
  }

  getDescription (props) {
    if (props.data.description.includes('\n')) {
      return props.data.description.split('\n')
        .map((desc, index, array) => index === array.length - 1
          ? <span key={desc}><br />{desc}</span>
          : <span key={desc}>{desc}</span>
        )
    }
    return props.data.description
  }

  render () {
    const name = this.getName(this.props)

    return (
      <div>
        <Hero {...this.props.data}>
          <HeroTitle className='ttc'>
            {name}
            <div className='center w3 mt2 bg-white'
              style={{
                height: '0.125rem',
              }}
            />
          </HeroTitle>
          <HeroSubtitle>
            {this.getDescription(this.props)}
          </HeroSubtitle>
        </Hero>
        <PageContent>
          <Section>
            <SectionTitle>Current Openings</SectionTitle>
            <PositionsTable hideDepartment department={name} />
          </Section>
          <Section>
            <SectionTitle>Other Departments</SectionTitle>
            <DepartmentsTable hiddenDepartments={[name]} />
          </Section>
        </PageContent>
      </div>
    )
  }
}

export default connect()(withRouter(DepartmentDetail))
